import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsApplianceDetailsSteppedMultiPlanBenefitsPanel } from './cms-appliance-details-stepped-multi-plan-benefits-panel.interface';
import { CmsApplianceDetailsSteppedMultiPlanForm } from './cms-appliance-details-stepped-multi-plan-form.interface';

export interface CmsApplianceDetailsSteppedMultiPlanPage
  extends CmsRegistrationRoot,
    CmsApplianceDetailsSteppedMultiPlanForm {
  applianceDetailsSteppedMultiPlanBenefitsPanel: CmsApplianceDetailsSteppedMultiPlanBenefitsPanel;
}
